import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useMeQuery } from '../../graphql/types';
import { color, gutter } from '../../styles/mixins';
import { p16 } from '../../styles/typography';
import { Button } from '../button/button';
import { RulesItem } from '../rules/rules-item';
import AuctionSvg from '../svg/auction';
import CheckedSvg from '../svg/checked';
import DashboardsSvg from '../svg/dashboard';
import PaddleSvg from '../svg/paddle';
import { Content, Copy, Host, Sticky } from './shared';
import useActiveYear from '../../hooks/useActiveYear';

const Heading = styled.h3`
  ${p16};
  font-weight: 500;
  margin: 0;
  margin-bottom: ${gutter(2)};
  text-align: center;

  color: ${color('navy100')};
`;

export function Rules({
  paddleNumber,
  startsAt,
}: {
  paddleNumber?: number | null;
  startsAt: string;
}) {
  const me = useMeQuery({
    fetchPolicy: 'cache-only',
  });

  const ACTIVE_YEAR = useActiveYear();

  const num = paddleNumber ?? me.data?.me?.paddle?.number;
  const realStartsAt = startsAt || me.data?.activeAuction?.startsAt || 0;

  return (
    <Host>
      <Content>
        <Heading>
          {num ? `You Have Paddle Number ${num}` : 'You claimed a Paddle'}
        </Heading>
        <Copy style={{ paddingTop: 0, textAlign: 'center' }}>
          You may place bids once bidding opens
          {realStartsAt
            ? ` on
          ${new Date(realStartsAt).toLocaleDateString()}`
            : ''}
        </Copy>
        <br />
        <br />
        <RulesItem
          leftIcon={<PaddleSvg />}
          title="Leaderboard auction"
          copy="This is a leaderboad auction where the top 10 bids win the lot."
          rightIcon={<CheckedSvg />}
        />
        <RulesItem
          leftIcon={<DashboardsSvg />}
          title="Dashboard"
          copy="All bids are displayed in real-time on the vintners screen at the event."
          rightIcon={<CheckedSvg />}
        />
        <RulesItem
          leftIcon={<AuctionSvg />}
          title="Charity auction"
          copy="This is a charity auction with funds raised going towards caring for children’s mental health and well being."
          rightIcon={<CheckedSvg />}
        />
      </Content>
      <Sticky style={{ paddingBottom: 16 }}>
        <Button as={Link} to={`/${ACTIVE_YEAR}/lots`} fullWidth>
          Browse Lots
        </Button>
      </Sticky>
    </Host>
  );
}
